export enum AwardVisibility {
  VOTE = 'VOTE',
  SHOWCASE = 'SHOWCASE',
  SOURCING = 'SOURCING',
}
